// Utility file to store wordcloud temp data
// --------------------------------------------------------
const state = {
  useTags: true,
  useKeywords: true,
  keywordsMinDate: null,
  keywordsMaxDate: null
}
const getters = {
  useTags: state => state.useTags,
  useKeywords: state => state.useKeywords,
  keywordsMinDate: state => state.keywordsMinDate,
  keywordsMaxDate: state => state.keywordsMaxDate
}
const mutations = {
  setTags(state, b) {
    state.useTags = b
  },
  setKeywords(state, b) {
    state.useKeywords = b
  },
  setKeywordsDates(state, date) {
    state.keywordsMinDate = date.beginDate
    state.keywordsMaxDate = date.endDate
  }
}

export default {
  state,
  getters,
  mutations
}
